import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronLeft, FiChevronRight } = FiIcons;

const ProductScreens = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const screens = [
    {
      title: 'Job Publishing Dashboard',
      description: 'Create and publish jobs across multiple channels with one click',
      image: '/api/placeholder/800/500'
    },
    {
      title: 'Candidate Shortlist Grid',
      description: 'AI-powered candidate ranking with detailed scoring insights',
      image: '/api/placeholder/800/500'
    },
    {
      title: 'AI Scoring Panel',
      description: 'Comprehensive candidate analysis and recommendation engine',
      image: '/api/placeholder/800/500'
    },
    {
      title: 'Video Review Interface',
      description: 'Review candidate interviews with AI-generated insights',
      image: '/api/placeholder/800/500'
    },
    {
      title: 'Panel Comparison View',
      description: 'Compare multiple candidates side-by-side for better decisions',
      image: '/api/placeholder/800/500'
    },
    {
      title: 'Scheduling Module',
      description: 'Seamless interview scheduling with automated reminders',
      image: '/api/placeholder/800/500'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % screens.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + screens.length) % screens.length);
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            See Instashortlist in Action
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Explore our intuitive interface designed for modern recruitment teams
          </p>
        </motion.div>

        <div className="relative bg-slate-50 rounded-3xl p-8 lg:p-12">
          {/* Carousel */}
          <div className="relative overflow-hidden rounded-2xl">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentSlide}
                className="relative"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
              >
                {/* Mock Screenshot */}
                <div className="bg-white rounded-lg shadow-2xl overflow-hidden">
                  <div className="bg-slate-100 px-4 py-3 flex items-center space-x-2">
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                      <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                      <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                    </div>
                    <div className="flex-1 bg-white rounded px-3 py-1 text-sm text-slate-500">
                      app.instashortlist.com
                    </div>
                  </div>
                  
                  <div className="aspect-video bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center">
                    <div className="text-center">
                      <div className="w-24 h-24 bg-indigo-100 rounded-2xl mx-auto mb-4 flex items-center justify-center">
                        <div className="w-12 h-12 bg-indigo-600 rounded-lg"></div>
                      </div>
                      <h3 className="text-2xl font-semibold text-slate-900 mb-2">
                        {screens[currentSlide].title}
                      </h3>
                      <p className="text-slate-600 max-w-md mx-auto">
                        {screens[currentSlide].description}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all duration-200"
            >
              <SafeIcon icon={FiChevronLeft} className="w-6 h-6 text-slate-600" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center transition-all duration-200"
            >
              <SafeIcon icon={FiChevronRight} className="w-6 h-6 text-slate-600" />
            </button>
          </div>

          {/* Slide Indicators */}
          <div className="flex justify-center space-x-2 mt-8">
            {screens.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-200 ${
                  index === currentSlide 
                    ? 'bg-indigo-600 w-8' 
                    : 'bg-slate-300 hover:bg-slate-400'
                }`}
              />
            ))}
          </div>

          {/* CTA */}
          <motion.div
            className="text-center mt-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <button className="bg-indigo-600 text-white font-semibold px-8 py-4 rounded-lg hover:bg-indigo-700 transition-colors shadow-elegant">
              Request This View in Demo
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProductScreens;